import { render, staticRenderFns } from "./info.vue?vue&type=template&id=3c8b6bd2&scoped=true&lang=html&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&id=3c8b6bd2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b6bd2",
  null
  
)

component.options.__file = "info.vue"
export default component.exports